import { render, staticRenderFns } from "./ModuleAdmin.vue?vue&type=template&id=15326ea2&"
import script from "./ModuleAdmin.vue?vue&type=script&lang=js&"
export * from "./ModuleAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports